"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowForwardLine = void 0;
var react_1 = __importDefault(require("react"));
var grayScale_1 = require("../../color/grayScale");
function ArrowForwardLine(_a) {
    var size = _a.size, color = _a.color;
    switch (size) {
        case 20:
            return (react_1.default.createElement("svg", { width: "20", height: "21", viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("g", { clipPath: "url(#clip0_575_15937)" },
                    react_1.default.createElement("path", { d: "M10.0007 3.8335L8.82565 5.0085L13.4757 9.66683H3.33398V11.3335H13.4757L8.82565 15.9918L10.0007 17.1668L16.6673 10.5002L10.0007 3.8335Z", fill: color !== null && color !== void 0 ? color : grayScale_1.grayScale.gray100 })),
                react_1.default.createElement("defs", null,
                    react_1.default.createElement("clipPath", { id: "clip0_575_15937" },
                        react_1.default.createElement("rect", { width: "20", height: "20", fill: "none", transform: "translate(0 0.5)" })))));
        case 24:
            return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("g", { clipPath: "url(#clip0_575_15220)" },
                    react_1.default.createElement("path", { d: "M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z", fill: color !== null && color !== void 0 ? color : grayScale_1.grayScale.gray100 })),
                react_1.default.createElement("defs", null,
                    react_1.default.createElement("clipPath", { id: "clip0_575_15220" },
                        react_1.default.createElement("rect", { width: "24", height: "24", fill: "none" })))));
    }
}
exports.ArrowForwardLine = ArrowForwardLine;
//# sourceMappingURL=ArrowForwardLine.js.map